import React, { useContext } from 'react';

import { Button } from '@vimeo/bokeh';
import { buildUpgradePlanUrl } from '@vimeo/picox';

import BpTracking from '../../utils/bpTracking';
import translations from '../../utils/translations';
import TrackingContext from '../common/TrackingContext';
import { FooterContainer } from './styles';

const Footer = () => {
  const trackingProps = useContext(TrackingContext);
  const footerCopy = translations.compareAllPlanFeatures;

  const handleClick = () => {
    BpTracking.trackButtonClick(
      {
        ...trackingProps.params,
        copy: footerCopy,
        device_type: trackingProps.device_type,
        path: window.location.href,
        target: 'upgrade',
        target_path: '/upgrade',
      },
      trackingProps.bpEventVersion,
    );

    if (trackingProps.onButtonClick) {
      trackingProps.onButtonClick({
        copy: footerCopy,
        target_path: '/upgrade',
      });
    }
  };

  return (
    <FooterContainer>
      <Button
        data-testid="upsell-cta"
        size="md"
        href={buildUpgradePlanUrl(trackingProps.paywallTracking, {
          upsell: trackingProps.params.upsell_name || 'none',
          integration: trackingProps.params.integration || 'none',
          feature: trackingProps.params.feature || 'none',
        })}
        target="_blank"
        as="a"
        variant="minmal"
        onClick={handleClick}
        _hover={{}}
      >
        {footerCopy}
      </Button>
    </FooterContainer>
  );
};

export default Footer;
